
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'

const domain = 'https://h5.thepage.cn';
@Options({
  data() {
    return {
      origin: '',
      isShowRule: false,
      isIndividualEnd: false,
      isTeamShow: false,
      isAiShow: false
    }
  },
  computed: {
    ...mapState(['aid', 'userInfo', 'shareData', 'activityData'])
  },
  created() {
    this.origin = this.$route.query.origin || ""
  },
  mounted() {
    this.$common.pageLoaded()
    let homeShareData = JSON.parse(JSON.stringify(this.shareData))
    homeShareData.link = window.location.href
    this.getBtnState()
    this.$common.onshare(homeShareData)
    this.$common.track('load', '进入首页')
  },
  methods: {
    ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_ACTIVITYDATA']),
    getBtnState () {
        if (this.activityData && this.activityData.templateConfig) {
            if (this.activityData.templateConfig.individualEndTime) {
                this.isIndividualEnd = new Date(this.activityData.serverTime).getTime() > new Date(this.activityData.templateConfig.individualEndTime).getTime()
            }
            if (this.activityData.templateConfig.teamTime) {
                this.isTeamShow = new Date(this.activityData.serverTime).getTime() > new Date(this.activityData.templateConfig.teamTime[0]).getTime() && new Date(this.activityData.serverTime).getTime() <= new Date(this.activityData.templateConfig.teamTime[1]).getTime()
            }
            if (this.activityData.templateConfig.aiTime) {
                this.isAiShow = new Date(this.activityData.serverTime).getTime() > new Date(this.activityData.templateConfig.aiTime[0]).getTime() && new Date(this.activityData.serverTime).getTime() <= new Date(this.activityData.templateConfig.aiTime[1]).getTime()
            }
        }
    },
    handleStart(isTeam, path) {
      if (!COVERAPP.Attribute.isApp()) {
        this.SET_DIALOGDATA({
          text: '参加该活动需在封面新闻APP中进行',
          btns: [
            {
              text: '取消',
              className : 'cancel-btn'
            },
            {
              text: '确定',
              className : 'download-btn'
            }
          ]
        })
        return;
      }
      const _this = this;
      this.$common.getUser((res) => {
        const userinfo = JSON.parse(JSON.stringify(res));
        /* if (COVERAPP.Attribute.isIOS() && COVERAPP.Attribute.isApp() && userinfo.token) {
          if (COVERAPP.Attribute.appVersion() >= 450) {
            userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)))
          }
        } */
        this.SET_USERINFO(userinfo);
        if (!userinfo || !userinfo.token) {
          if (COVERAPP.Attribute.isApp()) {
            COVERAPP.Method.OpenLogin({
              callback(res) {
                if (res && res.token) {
                  if (path === 'prize') {
                    window.location.href = `${ domain }/blindbox/#/record?id=6449e51b255ef7004034a8af&origin=${ _this.origin }`;
                    return;
                  }

                  if (!userinfo.mobile) {
                    COVERAPP.Method.bindMobile({
                      callback() {
                        // _this.queryAnswer(isTeam);
                      },
                    });
                    return;
                  }
                  _this.queryAnswer(isTeam);
                }
              }
            });
            return;
          }

          alert('请先登录~');
          return;
        }

        if (path === 'prize') {
          window.location.href = `${ domain }/blindbox/#/record?id=6449e51b255ef7004034a8af&origin=${ this.origin }`;
          return;
        }

        if (!userinfo.mobile) {
          COVERAPP.Method.bindMobile({
            callback() {
              // _this.queryAnswer(isTeam);
            },
          });
          return;
        }
        if (path === 'ai') {
            this.queryAnswer(false, 'ai');
        } else {
            this.queryAnswer(isTeam);
        }
        
      });
    },
    async queryAnswer(isTeam, ai) {
      const activityData = this.activityData;
      let loadtime = setTimeout(() => {
        this.$common.pageLoading();
      }, 1500);
      const res = await this.$request("/answer/user/count", {
        aid: ai ? activityData.templateConfig.aiAid : this.aid,
        isTeam,
        userinfo: this.userInfo,
      }, 'post').catch(err => {
        this.SET_DIALOGDATA({
          text: (err.errmsg || `(${ err.errmsg })`) ||  "网络错误~",
          btns: [
            {
              text: '确定',
              className : 'cancel-btn'
            },
          ]
        })
      });
      this.$common.pageLoaded();
      clearTimeout(loadtime);
      const status = res.status;
      if (status === 0) {
        // 去团队赛
        if (isTeam) {
          window.location.href = domain + `/contestanswers/#/select?isTeam=1&origin=${ this.origin }&id=${ this.aid }`;
          return;
        }

        if (ai) {
            window.location.href = activityData.templateConfig.aiLink;
            return;
        }

        if (activityData.isOpenName || activityData.isOpenPhone) {
          window.location.href = domain + `/contestanswers/#/select?id=${ this.aid }&origin=${ this.origin }`;
          return;
        }

        window.location.href = domain + `/contestanswers/#/answer?id=${ this.aid }&origin=${ this.origin }`;
        return;
      }

      let statusText = {
        '2010': '答题未开始',
        '2011': '答题已结束',
        '2012': '已超过答题总数',
        '2013': '亲，您今日答题次数已用完，明天再来答题吧。',
        '2014': '已完成答题',
        '2015': '当日已完成团队赛答题'
      }
      
      this.SET_DIALOGDATA({
        text: statusText[status] ||  "网络错误~",
        btns: [
          {
            text: '确定',
            className : 'cancel-btn'
          },
        ]
      })
    },
    onRank() {
      window.location.href = `${ domain }/contestanswers/#/rank?id=${ this.aid }&origin=${ this.origin }`;
    },
  },
})
export default class Home extends Vue {}
